var React = require('react');

function IconAnimation1Inline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M379.037 79.9062H384.031L409 95.4062M379.037 79.9062C358.229 53.9062 294.341 1.90625 205.25 1.90625C116.159 1.90625 52.2705 53.9062 31.4627 79.9062M379.037 79.9062H31.4627M31.4627 79.9062H27.4676L1 95.4062M1 95.4062H409M1 95.4062V144.406H409V95.4062","stroke":"#23C865","strokeWidth":"2"}));
}

IconAnimation1Inline.defaultProps = {"width":"410","height":"146","viewBox":"0 0 410 146","fill":"none"};

module.exports = IconAnimation1Inline;

IconAnimation1Inline.default = IconAnimation1Inline;
